import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

export const PayPalCheckout = ({ pkg, reservationId, onPaid }) => {
  return (
    <div data-testid="paypal-checkout">
      <PayPalScriptProvider options={{ clientId: CLIENT_ID, currency: "USD", intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "pill", label: "pay" }}
          createOrder={async () => {
            const { data } = await axios.post(`${API}/payments/create-order`, { package: pkg });
            return data.order_id;
          }}
          onApprove={async (data) => {
            try {
              const res = await axios.post(`${API}/payments/capture-order`, {
                order_id: data.orderID,
                reservation_id: reservationId,
              });
              if (res.data.status === "COMPLETED") {
                toast.success("Payment complete! Your totes are booked.");
                onPaid(res.data.payment);
              } else {
                toast.error("Payment could not be completed.");
              }
            } catch {
              toast.error("Payment capture failed. Please try again.");
            }
          }}
          onError={() => toast.error("PayPal error. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
};
